import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import type { ContentfulArticleGroupModel } from 'autogen/swagger/all';
import { ReadMore } from 'autogen/translation-keys/trans-website-shared-buttons';
import InlineLinkActionButton from 'components/generic/InlineButton/InlineLinkActionButton';
import { Typography } from 'components/generic/typography';
import Flex from 'components/Layout/components/Flex';

// #region Styles
const StyledInlineLinkActionButton = styled(InlineLinkActionButton)`
    margin-left: auto;
`;
// #endregion Styles

type SwimlaneHeaderProps = Pick<ContentfulArticleGroupModel, 'seeMoreLink' | 'headline'>;

function SwimlaneHeader({ headline, seeMoreLink }: SwimlaneHeaderProps) {
    const { t } = useTranslation();

    return (
        <Flex.Row alignItems="end" gap={Spacing16} justifyContent="space-between">
            {headline && (
                <Typography.Headline size="M" as="h2">
                    {headline}
                </Typography.Headline>
            )}
            {seeMoreLink && (
                <StyledInlineLinkActionButton fontWeight="semibold" action={seeMoreLink}>
                    {t(ReadMore)}
                </StyledInlineLinkActionButton>
            )}
        </Flex.Row>
    );
}

export default withErrorBoundary(SwimlaneHeader, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
